export {EmojiService} from './src/emoji.service';
export {EmojiInputComponent} from './src/emoji-input/emoji-input.component';
export {EmojiPickerModule} from './emoji-picker.module';
